import React from 'react';

// Faithful in-app preview of the sent email (mirrors newsletter_send.render_html).
// Brand: coral #FF5757 accents, near-black #0A0A0B header, BillPortal mark.
export default function NewsletterPreview({ nl, categoryLabel }) {
  const sections = nl.sections || [];
  return (
    <div data-testid="newsletter-preview" className="overflow-hidden rounded-xl border border-slate-200 bg-slate-100 shadow-inner">
      {/* Inbox line */}
      <div className="flex items-center gap-2 border-b border-slate-200 bg-white px-4 py-2.5">
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#FF5757]/10 text-[10px] font-bold text-[#FF5757]">BP</span>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[13px] font-semibold text-slate-800">{nl.subject || 'Subject line…'}</div>
          <div className="truncate text-[11px] text-slate-400">{nl.preheader || 'Inbox preview text appears here'}</div>
        </div>
      </div>

      {/* Email body */}
      <div className="max-h-[70vh] overflow-y-auto p-4">
        <div className="mx-auto max-w-[600px] overflow-hidden rounded-[14px] border border-slate-200 bg-white">
          {/* Header */}
          <div className="px-7 py-5" style={{ background: '#0A0A0B' }}>
            <div className="flex items-center gap-2.5">
              <img src="/BP-Mark.png" alt="BillPortal" className="h-7 w-7 object-contain" />
              <span className="text-[20px] font-extrabold tracking-tight text-white">BillPortal</span>
            </div>
            <div className="mt-3 text-[11px] font-bold uppercase tracking-wider" style={{ color: '#FF5757' }}>
              {categoryLabel || 'BillPortal'} · Weekly Update
            </div>
          </div>

          {/* Content */}
          <div className="px-7 py-7">
            <p className="mb-5 whitespace-pre-line text-[15px] leading-relaxed text-slate-900">{nl.intro || 'Your intro paragraph will appear here.'}</p>

            {sections.length === 0 ? (
              <p className="rounded-md border border-dashed border-slate-200 p-4 text-center text-sm text-slate-400">Add sections to build the newsletter body.</p>
            ) : sections.map((s, i) => (
              <div key={i} className="mb-5 border-b border-slate-100 pb-5 last:border-0">
                <h3 className="mb-2 text-[17px] font-bold leading-snug text-slate-900">{s.heading || 'Section heading'}</h3>
                <p className="mb-2.5 whitespace-pre-line text-[14px] leading-relaxed text-slate-700">{s.body}</p>
                {s.source_url ? (
                  <a href={s.source_url} target="_blank" rel="noreferrer" data-testid={`preview-source-${i}`} className="text-[13px] font-bold hover:underline" style={{ color: '#FF5757' }}>Read the full article →</a>
                ) : null}
              </div>
            ))}

            <div className="my-3 text-center">
              <a href="/blog" target="_blank" rel="noreferrer" data-testid="preview-cta" className="inline-block rounded-lg px-6 py-3 text-[14px] font-bold text-white" style={{ background: '#FF5757' }}>Read the full round-up on BillPortal</a>
              <div className="mt-2.5"><a href="/demo" target="_blank" rel="noreferrer" className="text-[13px] font-semibold text-slate-900 underline">Or book a 30-min walkthrough →</a></div>
            </div>
            {nl.signoff ? <p className="mt-5 text-[14px] text-slate-600">{nl.signoff}</p> : null}
          </div>
        </div>
        <div className="mx-auto mt-4 max-w-[600px] px-3 text-center text-[11px] leading-relaxed text-slate-400">
          <a href="/blog" className="font-semibold" style={{ color: '#0035A8' }}>Forward to a colleague</a> · <a href="/blog" className="font-semibold" style={{ color: '#0035A8' }}>Subscribe</a><br /><br />
          BillPortal Technologies Inc. · You're receiving this because you subscribed to {categoryLabel || 'BillPortal'} updates. External headlines are summarised for commentary; all rights remain with the original publishers.<br />
          <span className="underline">Unsubscribe</span>
        </div>
      </div>
    </div>
  );
}
